<template>
  <v-dialog scrollable v-model="dialog" width="90%">
    <template v-slot:activator="{ on }">
      <v-btn outlined v-on="on">
        <v-icon>
          mdi-plus
        </v-icon>
            Add communication log
      </v-btn>
    </template>

    <v-card>
      <v-card-title>Teacher's Communication Log
<v-spacer/>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      
      <v-row class="mx-2">
        <v-col cols="6">
          <v-select dense v-model="selectedStudentId" label="Choose Student" outlined :items="students" item-text="name" item-value="id"></v-select>
        </v-col>
         <v-col cols="6">
        <v-select dense v-model="selectedCourseId" label="Choose Course" outlined :items="courses" item-text="name" item-value="id"></v-select>
         </v-col>

         <v-col cols="12">
          <v-select dense v-model="selectedScheduleId" label="Choose Session" outlined :items="schedules" item-text="name" item-value="id"></v-select>
         </v-col>

         <v-col cols="12">
          <v-select dense v-model="selectedTopicId" :disabled="!topics || topics.length < 1" :label="(!topics || topics.length < 1) ? 'No topic available for selected session':'Choose a topic'" outlined :items="topics" item-text="name" item-value="id"></v-select>
         </v-col>
      </v-row>
      <v-card>
        <v-card-title>
          Ratings & Comments
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" lg="4">
              Comprehension
            </v-col>
            <v-col cols="12" lg="8">
              <v-rating hover v-model="ratings.comprehension" length="10"></v-rating>
            </v-col>
            <v-col cols="12" lg="4">
              Motivation
            </v-col>
            <v-col cols="12" lg="8">
              <v-rating hover v-model="ratings.motivation" length="10"></v-rating>
            </v-col>
            <v-col cols="12" lg="4">
              Participation
            </v-col>
            <v-col cols="12" lg="8">
              <v-rating hover v-model="ratings.participation" length="10"></v-rating>
            </v-col>
          </v-row>
        </v-card-text>

        <v-textarea v-model="comments" auto-grow :row-height="5" class="mx-5" label="Comments">
          </v-textarea>
          <v-card-actions>
            <v-spacer/>
            <v-btn @click="addCommunicationLog" color="primary" class="ma-5">Save</v-btn>
            <v-btn @click="dialog= false"  class="ma-5">Cancel</v-btn>
            <v-spacer/>
          </v-card-actions>
      </v-card>
      
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from 'moment';

export default {
  props: {
    selectedCourse: {
      type: Object,
      required: true
    },
  },
  data: () => ({
    dialog: false,
    ratings: {comprehension: 5, motivation: 5, participation: 5},
    courses: [],
    selectedCourseId: null,
    selectedScheduleId: null,
    selectedStudentId: null,
    selectedTopicId: null,
    scheduleSelectItems: [],
    schedules: [],
    students: [],
    comments: ''
  }),
  computed: {
    ...mapGetters(["currentUser", "isAppLoading"]),
    topics(){
      const selectedCourseSchedule = this.selectedCourse.courseSchedules.find( cs => cs.id == this.selectedScheduleId);
      if(selectedCourseSchedule){
        const topicIds = selectedCourseSchedule['schedule.topicSchedule'].map( ts => ts.topicId) || [];
        return this.selectedCourse.courseTopics.filter( ct => topicIds.includes(ct.topic.id) ).map( ct => ct.topic);
      }
      else{
        return [];
      }
    }
  },
  methods: {
    ...mapActions(['addSuccessMessage', 'addErrorMessage']),
    addCommunicationLog(){
      const data = {
        comments: this.comments,
        comprehension: this.ratings.comprehension,
        motivation: this.ratings.motivation,
        participation: this.ratings.participation,
        courseId: this.selectedCourseId,
        courseScheduleId: this.selectedScheduleId,
        studentid: this.selectedStudentId,
        teacherid: this.currentUser.uId,
        topicId: this.selectedTopicId
      }
      this.$axios.post( '/course/addTeacherComment', data )
        .then( resp => {
          console.log(resp);
          this.addSuccessMessage('Communication log saved')
          this.dialog = false;
        })
        .catch(error => {
          this.addErrorMessage(error.message)
        })
    }
  },
  mounted(){
    if(this.selectedCourse){
      this.courses = [this.selectedCourse];
      this.selectedCourseId = this.selectedCourse.id;

      const topicId2Name = {};
      this.selectedCourse.courseTopics.forEach( ct => {
        topicId2Name[ct.topic.id] = ct.topic.name;
      });

      if(this.selectedCourse.courseSchedules){
        this.schedules = this.selectedCourse.courseSchedules.map( cs => { 
          const sessionDate = moment(cs.start);
          const label = `${sessionDate.format('MMMM Do YYYY, h:mm a')}`;
          const disabled = sessionDate.isAfter(moment());
          return { id: cs.id, name: label, disabled }
        });
      }

      if(this.selectedCourse.courseStudents){
        this.students = this.selectedCourse.courseStudents.map( cs => { return { name: `${cs.student.firstName} ${cs.student.lastName}`, ...cs.student }});
      }
    }
  }
};
</script>

<style>
</style>